import React, { useState, useRef, useEffect } from 'react';
import { Modal, Stepper } from 'antd-mobile';
import { CheckTimeInterval, TimeInterval } from '@/pages/manage/common';
import moment from 'moment';
import LayoutModal from '@/pages/manage/components/layoutModal';
import { Button } from 'antd-mobile';
import _ from 'lodash';
import { conferenceStart, conferenceEnd } from '@/services/saas/conference';
import './index.scss';

const NO_CHECK_DISABLE = false;

const ControlWrapper = (props) => {
  const { id, roomId, isHide, children } = props;

  const newProps = {};
  if (id) newProps.id = id;
  if (roomId) newProps.roomId = roomId;

  return (
    <div className={`control-wrapper ${isHide ? 'hide' : 'show'}`}>
      {React.Children.map(children, (child) => {
        let tnewProps = newProps;
        return React.cloneElement(child, tnewProps);
      })}
    </div>
  );
};

const ControlCard = (props) => {
  const { title, type, status, noDelay, titleType, onClick } = props;

  const handleClick = useRef(
    _.debounce(() => {
      onClick();
    }, 500),
  ).current;

  return (
    <div
      className={`control-card ${titleType ? titleType : ''}`}
      onClick={noDelay ? onClick : handleClick}
    >
      <div className={`control-card-btn ${type ? type : ''} ${status ? status : ''}`}>
        <em></em>
        <span className="title">{title}</span>
      </div>
    </div>
  );
};

const PlatRecordStatus = {
  nostart: 'off',
  started: 'off',
  recording: 'on',
  stopping: 'off',
  stopped: 'off',
  error: 'off',
  fatal: 'off',
};

const PlatRecord = (props) => {
  const titleStatus = {
    nostart: '平台录制关闭',
    started: '平台录制开启中',
    recording: '平台录制中',
    stopping: '平台录制停止中',
    stopped: '平台录制关闭',
    error: '平台录制关闭',
    fatal: '平台录制失败',
  };

  const noClick = ['started', 'stopping'];

  // const { id, status, handleClick } = props;

  const { status } = props;

  const propsRef = useRef();

  const onClick = () => {
    const {
      current: { id, status, handleClick },
    } = propsRef;
    if (noClick.indexOf(status) > -1) {
      return;
    }
    let operation = null;
    switch (status) {
      case 'recording':
        // 停止
        operation = 'stop';
        break;
      case 'nostart':
        // 没开始
        operation = 'start';
        break;
      case 'stopped':
        // 停止
        operation = 'start';
        break;
      default:
        operation = undefined;
        break;
    }
    if (NO_CHECK_DISABLE || operation) {
      if (handleClick) handleClick({ id, operation });
    }
  };

  useEffect(() => {
    propsRef.current = props;
  }, [props]);

  // const tempStatus = status === 'nostart'|| status === 'stopped'|| !status ;

  return (
    <ControlCard
      type="record"
      title={titleStatus[status] || '录制'}
      onClick={onClick}
      status={PlatRecordStatus[status]}
    ></ControlCard>
  );
};

const LocalRecord = (props) => {
  const titleStatus = {
    '0': '本地录制停止',
    '1': '本地录制开启',
  };

  const { status } = props;

  const statusTemplate = { '0': 'off', '1': 'on' };

  const propsRef = useRef();

  const onClick = () => {
    const {
      current: { roomId, status, handleClick },
    } = propsRef;
    if (NO_CHECK_DISABLE || status != null) {
      if (handleClick) handleClick({ roomId, operation: status * 1 ? '0' : '1' });
    }
  };

  useEffect(() => {
    propsRef.current = props;
  }, [props]);

  return (
    <ControlCard
      type="record"
      title={titleStatus[status] || '本地录制'}
      onClick={onClick}
      status={statusTemplate[status]}
    ></ControlCard>
  );
};

const RollCall = (props) => {
  const titleStatus = {
    '1': '主讲已点名',
    '0': '主讲未点名',
  };

  const { status } = props;

  const statusTemplate = { '0': 'off', '1': 'on' };

  const propsRef = useRef();

  const onClick = () => {
    const {
      current: { roomId, status, handleClick },
    } = propsRef;
    if (NO_CHECK_DISABLE || status != null) {
      if (handleClick) handleClick({ roomId, operation: status * 1 ? '0' : '1' });
    }
  };

  useEffect(() => {
    propsRef.current = props;
  }, [props]);

  // const tempStatus = status === 'nostart'|| status === 'stopped'|| !status ;

  return (
    <ControlCard
      type="target"
      title={titleStatus[status] || '主讲点名'}
      onClick={onClick}
      status={statusTemplate[status]}
    ></ControlCard>
  );
};

const RecordStop = (props) => {
  const propsRef = useRef();

  const { status } = props;

  const onClick = () => {
    const {
      current: { id, status, handleClick },
    } = propsRef;
    if (NO_CHECK_DISABLE && status) {
      if (handleClick) handleClick({ id, operation: 'stop' });
    }
  };

  useEffect(() => {
    propsRef.current = props;
  }, [props]);

  return (
    <ControlCard
      type="record-stop"
      title={'停止录制'}
      onClick={onClick}
      status={PlatRecordStatus[status]}
    ></ControlCard>
  );
};

const PlatLive = (props) => {
  const propsRef = useRef();

  const titleStatus = {
    nostart: '直播关闭',
    started: '开启中',
    living: '直播打开',
    stopping: '停止中',
    stopped: '直播关闭',
    error: '直播错误',
  };

  const statusTemplate = {
    nostart: 'off',
    started: 'off',
    living: 'on',
    stopping: 'on',
    stopped: 'off',
    error: 'off',
  };

  const noClick = ['started', 'stopping'];

  const { status } = props;

  const onClick = () => {
    const {
      current: { id, status, handleClick },
    } = propsRef;
    if (noClick.indexOf(status) > -1) {
      return;
    }
    let operation = null;
    switch (status) {
      case 'living':
        // 暂停
        operation = 'stop';
        break;
      case 'nostart':
        // 停止
        operation = 'start';
        break;
      case 'stopped':
        // 停止
        operation = 'start';
        break;
      default:
        operation = '';
        break;
    }
    if (NO_CHECK_DISABLE || operation) {
      if (handleClick) handleClick({ id, operation });
    }
  };

  useEffect(() => {
    propsRef.current = props;
  }, [props]);

  return (
    <ControlCard
      type="live"
      title={titleStatus[status] || '直播'}
      onClick={onClick}
      status={statusTemplate[status]}
    ></ControlCard>
  );
};

const DoubleContent = (props) => {
  const propsRef = useRef();

  const titleStatus = { '0': '课件关闭', '1': '课件打开' };

  const statusTemplate = { '0': 'off', '1': 'on' };

  const { status } = props;

  const onClick = () => {
    const {
      current: { roomId, status, handleClick },
    } = propsRef;
    if (NO_CHECK_DISABLE || status != null) {
      if (handleClick) handleClick({ roomId, operation: status * 1 ? '0' : '1' });
    }
  };

  useEffect(() => {
    propsRef.current = props;
  }, [props]);

  return (
    <ControlCard
      type="stream"
      title={titleStatus[status] || '课件'}
      onClick={onClick}
      status={statusTemplate[status]}
    ></ControlCard>
  );
};

const AutoSpeak = (props) => {
  const propsRef = useRef();

  const titleStatus = { '0': '发言关闭', '1': '发言打开' };

  const statusTemplate = { '0': 'off', '1': 'on' };

  const { status } = props;

  const onClick = () => {
    const {
      current: { id, status, handleClick },
    } = propsRef;
    if (NO_CHECK_DISABLE || status != null) {
      if (handleClick) handleClick({ id, operation: status * 1 ? '0' : '1' });
    }
  };

  useEffect(() => {
    propsRef.current = props;
  }, [props]);

  return (
    <ControlCard
      type="speak"
      title={titleStatus[status] || '自动发言'}
      onClick={onClick}
      status={statusTemplate[status]}
    ></ControlCard>
  );
};

const TrackMode = (props) => {
  const propsRef = useRef();

  const titleStatus = { '0': '跟踪打开', '1': '跟踪关闭' };

  const statusTemplate = { '0': 'on', '1': 'off' };

  const { status } = props;

  const onClick = () => {
    const {
      current: { roomId, status, handleClick },
    } = propsRef;
    if (NO_CHECK_DISABLE || propsRef.current.status != null) {
      if (handleClick) handleClick({ roomId, operation: status * 1 ? '0' : '1' });
    }
  };

  useEffect(() => {
    propsRef.current = props;
  }, [props]);

  return (
    <ControlCard
      type="track"
      title={titleStatus[status] || '自动跟踪'}
      onClick={onClick}
      status={statusTemplate[status]}
    ></ControlCard>
  );
};

const LayoutMode = (props) => {
  const propsRef = useRef();

  const { status = {} } = props;

  const [visible, setVisible] = useState(false);

  const onClick = () => {
    setVisible(true);
  };

  const onChange = (code, [policyId, pipPos]) => {
    const {
      current: { roomId, handleChange },
    } = propsRef;
    if (handleChange) handleChange({ roomId, policyId, pipPos });
  };

  const handleClick = useRef(
    _.debounce((...param) => {
      onChange(...param);
    }, 500),
  ).current;

  useEffect(() => {
    propsRef.current = props;
  }, [props]);

  return (
    <>
      <ControlCard
        type="layout"
        title={'布局选择'}
        onClick={onClick}
        status={status ? 'on' : ''}
        noDelay={true}
      ></ControlCard>
      <LayoutModal
        value={[status.policyCode, status.pipPos]}
        visible={visible}
        onModalChange={() => setVisible(false)}
        onChange={handleClick}
      ></LayoutModal>
    </>
  );
};

const StartButton = (props) => {
  const propsRef = useRef();

  const statusText = { '0': '开始课程', '1': '点击结束', '2': '已结束' };
  const iconMap = {
    '0': (
      <svg
        t="1629854009882"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="1268"
        fill="#ffffff"
      >
        <path
          d="M341.32992 731.37152a53.73952 53.73952 0 0 0 53.77024 53.69856h0.43008c18.8416 0 35.90144-7.59808 48.27136-19.99872l228.92544-228.74112a34.1504 34.1504 0 0 0 0-48.19968L443.36128 258.92864a68.096 68.096 0 0 0-48.27136-19.99872 53.69856 53.69856 0 0 0-53.77024 53.73952v438.70208z"
          p-id="1269"
        ></path>
      </svg>
    ),
    '1': (
      <svg
        t="1629854073146"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="1416"
      >
        <path
          d="M785.07008 716.8c0 37.5296-30.74048 68.27008-68.27008 68.27008H307.2c-37.5296 0-68.27008-30.74048-68.27008-68.27008V307.2c0-37.5296 30.74048-68.27008 68.27008-68.27008h409.6c37.5296 0 68.27008 30.74048 68.27008 68.27008v409.6z"
          p-id="1417"
          fill="#ffffff"
        ></path>
      </svg>
    ),
  };

  const { status, withIcon = false } = props;

  const onClick = (e) => {
    const {
      current: { status, handleStart, handleEnd },
    } = propsRef;
    if (status === '0') {
      handleStart();
    }
    if (status === '1') {
      handleEnd();
    }
  };

  const handleClick = useRef(
    _.debounce((e) => {
      onClick(e);
    }, 500),
  ).current;

  useEffect(() => {
    propsRef.current = props;
  }, [props]);

  return (
    <div onClick={(e) => e.stopPropagation()} style={{ display: 'inline-block' }}>
      <Button className={`elem-button ${status === '1' ? 'on' : ''}`} onClick={handleClick}>
        <span>{withIcon ? iconMap[status] : null}</span>
        <span>{statusText[status] || '开始课程'}</span>
      </Button>
    </div>
  );
};

const RestartButton = ({ id, socket }) => {
  const handleRestart = async () => {
    socket.banBack = true;
    const responseEnd = await conferenceEnd({ id });
    if (responseEnd && responseEnd.success) {
      conferenceStart({ id });
      socket.banBack = false;
    }
  };

  return (
    <div onClick={(e) => e.stopPropagation()} style={{ display: 'inline-block' }}>
      <Button
        className="elem-button"
        onClick={() => {
          Modal.alert('确认重新开课', '是否重新开课?', [
            { text: '取消' },
            { text: '确定', onPress: handleRestart },
          ]);
        }}
      >
        <span>重新开课</span>
      </Button>
    </div>
  );
};

export const TimeClock = (props) => {
  const { value, onClick, onChange } = props;

  const [t, setT] = useState(undefined);

  const [time, setTime] = useState(undefined);

  useEffect(() => {
    if (value !== null && value !== undefined && t !== undefined) {
      t.setTime(value);
    }
  }, [t, value]);

  useEffect(() => {
    const timeObj = new TimeInterval((tt) => {
      setTime(tt);
      if (onChange) onChange(tt);
    });
    timeObj.start();
    setT(timeObj);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div onClick={onClick}>{(time && moment(time).utc().format('HH:mm:ss')) || '00:00:00'}</div>
  );
};

export const PlusTimeModal = (props) => {
  const clockRef = useRef({ flag: true });

  const { currect, startTime, endTime, visible, handleOk, handleClose } = props;

  const [time, setTime] = useState(undefined);

  const [value, setValue] = useState(5);

  const [localVisible, setLocalVisible] = useState(false);

  const setTimeBeat = (currect, startTime, endTime) => {
    const t = endTime - (startTime + currect);
    if (endTime !== null && t > 0) {
      setTime(t);
    }
  };

  useEffect(() => {
    if (currect && startTime && endTime) {
      if (!clockRef.current.check) {
        const checkObj = new CheckTimeInterval(() => {
          if (clockRef.current.flag) {
            setLocalVisible(true);
          }
        });
        checkObj.setParam({ startTime, endTime, currect });
        checkObj.start();
        clockRef.current.check = checkObj;
      } else {
        clockRef.current.check.setParam({ startTime, endTime, currect });
      }

      setTimeBeat(currect, startTime, endTime);
    } else {
      setTime(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currect, endTime, startTime, visible]);

  return (
    <Modal
      className="layout-modal"
      transparent
      visible={visible || localVisible}
      onClose={() => {
        handleClose();
        setLocalVisible(false);
      }}
      style={{ width: '30vw' }}
      title={'加时'}
      footer={[
        {
          text: '取消',
          onPress: () => {
            clockRef.current.flag = false;
            handleClose();
            setLocalVisible(false);
          },
        },
        {
          text: '确定',
          onPress: () => {
            clockRef.current.flag = true;
            handleOk(value);
            setLocalVisible(false);
          },
        },
      ]}
    >
      <div>
        需要延长
        <Stepper style={{ width: '8vw' }} showNumber min={5} value={value} onChange={setValue} />
        分钟吗?
        {time && `剩余: ${moment(time).utc().format('HH:mm:ss')}`}
      </div>
    </Modal>
  );
};

export {
  PlatRecord,
  RecordStop,
  PlatLive,
  DoubleContent,
  AutoSpeak,
  TrackMode,
  LayoutMode,
  StartButton,
  RestartButton,
  ControlWrapper,
  LocalRecord,
  RollCall,
};
